export const IS_REGISTER_KEY_SCRIPT = 'isReg';
export const REGISTERED_ACTION_KEY_SCRIPT = 'registerSuccess';
export const LOGIN_ACTION_KEY_SCRIPT = 'loginSuccess';

export function executeScriptFunction(name) {
  if (window[name] && typeof window[name] == 'function') {
    window[name]();
  }
}
